const iso8601DurationRegex =
  /(-)?P(?:([.,\d]+)Y)?(?:([.,\d]+)M)?(?:([.,\d]+)W)?(?:([.,\d]+)D)?T?(?:([.,\d]+)H)?(?:([.,\d]+)M)?(?:([.,\d]+)S)?/;

export function parseISO8601Duration(iso8601Duration: string): {
  duration: {
    years?: number;
    months?: number;
    weeks?: number;
    days?: number;
    hours?: number;
    minutes?: number;
    seconds?: number;
  };
  inputDuration: {
    days: string;
    hours: string;
    minutes: string;
    months: string;
    seconds: string;
    weeks: string;
    years: string;
  };
} {
  const matches = iso8601DurationRegex.exec(iso8601Duration);
  const matchesNumber = matches.map(Number);
  const duration = {
    years: matchesNumber[2] || 0,
    months: matchesNumber[3] || 0,
    weeks: matchesNumber[4] || 0,
    days: matchesNumber[5] || 0,
    hours: matchesNumber[6] || 0,
    minutes: matchesNumber[7] || 0,
    seconds: matchesNumber[8] || 0,
  };
  const inputDuration = {
    years: '00',
    months: '00',
    weeks: '00',
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00',
  };

  for (const key of Object.keys(duration)) {
    inputDuration[key] = duration[key].toString().padStart(2, '0');
  }

  return {
    duration,
    inputDuration,
  };
}
